import { GitHubBanner, Refine, Authenticated } from "@refinedev/core";
import { notificationProvider, ErrorComponent } from "@refinedev/antd";
import { dataProvider, liveProvider } from "@refinedev/supabase";
import routerBindings, { NavigateToResource } from "@refinedev/react-router-v6";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { ThemeProvider } from "@mui/material";
import { GithubOutlined } from "@ant-design/icons";

import { Layout } from "components/layout";
import { CanvasFeaturedList, CanvasList, CanvasShow } from "pages/canvases";
import { AuthPage } from "pages/auth";

import { supabaseClient } from "utility";
import { authProvider, auditLogProvider, theme } from "./providers";

import "@refinedev/antd/dist/reset.css";

import "styles/style.css";

function App() {
  return (
    <BrowserRouter>
      <GitHubBanner />
      <ThemeProvider theme={theme}>
        <Refine
          authProvider={authProvider}
          dataProvider={dataProvider(supabaseClient)}
          liveProvider={liveProvider(supabaseClient)}
          auditLogProvider={auditLogProvider}
          routerProvider={routerBindings}
          resources={[
            {
              name: "canvases",
              list: "/canvases",
              show: "/canvases/show/:id",
            },
          ]}
          notificationProvider={notificationProvider}
        >
          <Routes>
            <Route
              element={
                <Layout>
                  <Outlet />
                </Layout>
              }
            >
              <Route index element={<CanvasFeaturedList />} />

              <Route path="/canvases">
                <Route index element={<CanvasList />} />
                <Route path="show/:id" element={<CanvasShow />} />
              </Route>
            </Route>
            <Route
              element={
                <Authenticated fallback={<Outlet />}>
                  <NavigateToResource />
                </Authenticated>
              }
            >
              <Route
                path="/login"
                element={
                  <AuthPage
                    type="login"
                    providers={[
                      {
                        name: "github",
                        icon: (
                          <GithubOutlined
                            style={{
                              fontSize: "18px",
                            }}
                          />
                        ),
                        label: "Sign in with GitHub",
                      },
                    ]}
                  />
                }
              />
              <Route path="/register" element={<AuthPage type="register" />} />
              <Route
                path="/forgot-password"
                element={<AuthPage type="forgotPassword" />}
              />
              <Route
                path="/update-password"
                element={<AuthPage type="updatePassword" />}
              />
            </Route>

            <Route
              element={
                <Layout>
                  <Outlet />
                </Layout>
              }
            >
              <Route path="*" element={<ErrorComponent />} />
            </Route>
          </Routes>
        </Refine>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
